module.exports = __webpack_public_path__ + "static/media/Ulrike.39c50b03.png";